<div class="content">
  <div class="configurationBannerHeader" (click)="toggleExpansion()">
    <label class="configurationBannerLabel">Accessories</label>
    <span class="spacer"></span>
    <mat-icon class="expansionIcon">{{ getExpansionIcon() }}</mat-icon>
  </div>
  @if (isExpanded) {
    <div class="detail">
      <div class="configurationOptions">
        <div class="configurationDetailRow">
          @if (emergencyHeaterSelection) {
            <span class="fullWidthConfigurationInput">
              <label class="halfWidthInputLabel">Emergency Heater:</label>
              <select class="halfWidthInputField" #emergencyHeaterInput
                [class.invalidConfigurationSelection]="isInvalidSelection(emergencyHeaterSelection.Name)"
                (change)="selectionChanged(emergencyHeaterSelection, emergencyHeaterInput.value)"
                [value]="emergencyHeaterSelection.Value.toString()">
                @for (allowable of emergencyHeaterSelection.Allowables; track allowable) {
                  <option
                    [class.invalidSelectorValue]="!allowable.IsValid" class="configurationSelectionOption"
                    [selected]="emergencyHeaterSelection.Value && emergencyHeaterSelection.Value.toString() === allowable.Value"
                  [value]="allowable.Value">{{ allowable.Description }}</option>
                }
              </select>
            </span>
          }
        </div>
        <div class="configurationDetailRow">
          @if (wallPlateSelection) {
            <span class="fullWidthConfigurationInput">
              <label [class.invalidConfigurationSelection]="isInvalidSelection(wallPlateSelection.Name)"
              for="wallPlateInput" class="halfWidthInputLabel">Wall Plate:</label>
              <input type="checkbox" class="checkboxInput" id="wallPlateInput"
                #wallPlateInput [checked]="'true' === wallPlateSelection.Value"
                (change)="selectionChanged(wallPlateSelection, wallPlateInput.checked.toString())">
            </span>
          }
        </div>
      </div>
    </div>
  }
</div>
